var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 26,
    fill: "none",
    viewBox: "0 0 24 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2789_3688)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#207245",
    d: "M12.463 0h1.608v2.419c2.71 0 5.42.006 8.13-.01.457.021.96-.015 1.358.29.279.448.247 1.016.265 1.53-.013 5.249-.008 10.494-.005 15.74-.013.88.073 1.777-.092 2.645-.108.629-.785.644-1.237.665-2.804.009-5.612-.006-8.419 0V26H12.39C8.264 25.162 4.13 24.389 0 23.581V2.421C4.155 1.615 8.31.82 12.463 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.074 3.326h8.933v19.046h-8.933v-1.814h2.166v-2.116h-2.166v-1.21h2.166v-2.116h-2.166v-1.209h2.166v-2.116h-2.166v-1.21h2.166V8.466h-2.166v-1.21h2.166V5.14h-2.166V3.326z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#207245",
    d: "M17.32 5.14h3.79v2.116h-3.79V5.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.018 7.972c.612-.048 1.227-.09 1.841-.124a663.55 663.55 0 01-2.184 4.955c.744 1.693 1.504 3.374 2.252 5.067-.652-.041-1.304-.088-1.955-.139-.46-1.26-1.02-2.479-1.35-3.797-.369 1.228-.894 2.385-1.316 3.589a58.35 58.35 0 01-1.779-.064c.696-1.52 1.367-3.053 2.085-4.565-.61-1.557-1.278-3.084-1.906-4.632.595-.039 1.19-.078 1.786-.114.404 1.182.845 2.348 1.178 3.561.357-1.285.89-2.494 1.348-3.737z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#207245",
    d: "M17.32 8.465h3.79v2.116h-3.79V8.465zm0 3.326h3.79v2.116h-3.79V11.79zm0 3.325h3.79v2.117h-3.79v-2.117zm0 3.326h3.79v2.116h-3.79v-2.116z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2789_3688"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H23.833V26H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.696be46dc810d27388bdc2aa115b4b97.svg";
export { ForwardRef as ReactComponent };